function Terms() {
  return (
    <div className="max-w-5xl mx-auto py-20 px-6">

      <h1 className="text-3xl font-bold mb-6">Terms & Conditions</h1>

      <p className="text-gray-600 mb-4">
        By using RentEase services, you agree to our rental policies.
      </p>

      <p className="text-gray-600 mb-4">
        Products must be returned in good condition. Damages may incur
        additional charges.
      </p>

      <p className="text-gray-600">
        RentEase reserves the right to update policies at any time.
      </p>

    </div>
  );
}

export default Terms;
